import React from 'react';
import type { DrawerProps } from '@archipro-design/aria';
import { Caption } from '@archipro-design/aria';
import {
    Button,
    Drawer,
    useStyles,
    Grid,
    pxToRem,
} from '@archipro-design/aria';
import type { CartItem as CartItemType } from '../../type/cart-item';
import CartItem from './CartItem';
import * as S from './LastAddedPopup.mobile.style';
import { ArrowRightLine, CheckLine, TimesLight } from '@archipro-design/icons';
import { useCartPopupState } from '../../context/CartPopupContext';

interface Props extends Omit<DrawerProps, 'content' | 'children'> {
    item: CartItemType | null;
}

const LastAddedPopup = ({ item, ...rest }: Props) => {
    const { css } = useStyles();
    const { onChange: onPopupChange } = useCartPopupState();

    return (
        <Drawer
            anchor="bottom"
            positionFixed
            className={css(S.Drawer)}
            content={{
                children: (
                    <div className={css(S.DrawerContent)}>
                        <Grid
                            columns={`${pxToRem(32)} 1fr ${pxToRem(46)}`}
                            className={css(S.Header)}
                        >
                            <CheckLine size="2x" />
                            <Caption variant="01" weight="medium">
                                Added to cart
                            </Caption>
                            <Button
                                transparent
                                size={24}
                                icon={<TimesLight />}
                                onClick={(e) =>
                                    rest.onOpenChange?.(e, {
                                        open: false,
                                    })
                                }
                                variables={{
                                    iconPadding: 0,
                                }}
                            />
                        </Grid>
                        <ul className={css(S.ItemContainer)}>
                            {item && <CartItem data={item} />}
                        </ul>
                        <div>
                            <Button
                                className={css(S.BtnViewCart)}
                                as={'a'}
                                href={'/shopping-cart'}
                                size={16}
                                fluid
                                iconAfter={<ArrowRightLine />}
                                variables={{
                                    buttonSize16LineHeight: pxToRem(48),
                                    buttonPadding: '0',
                                    iconPadding: 0,
                                }}
                                onClick={() => onPopupChange(false)}
                            >
                                VIEW CART
                            </Button>
                        </div>
                    </div>
                ),
            }}
            {...rest}
        ></Drawer>
    );
};

export default LastAddedPopup;
